import React from "react";
import { ImageField } from "@/components/ImageField";

export const PhotoField = (props) => <ImageField {...props} />;
